module.exports = "h1 {\n    text-align: center;\n    margin-top: 10px;\n}\n\n.list-group-item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\ntd {\n    vertical-align: middle;\n}\n\nth {\n    font-size: 20px;\n}\n\n.list-group-item:first-child {\n    border-bottom:  #312783 medium solid;\n    border-top: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/judge-editor/judge-editor.component.css
// module id = ./src/app/judge-editor/judge-editor.component.css
// module chunks = main